import type { FaireProductEntity } from "../../entity_types/product";

export const p_sy5zkh37xf: FaireProductEntity = {
  token: "p_sy5zkh37xf",
  type: "product",
  name: "LONG SLEEVE CREW NECK POLKA DOT SWEATER CARDIGAN",
  brandToken: "b_q8gu9by5sv",
  brandName: "LE LIS",
  imageUrl:
    "https://cdn.faire.com/fastly/2c0c95da516b4e9dc038e8edf7a59b4486da9b1c5606a216ca438c96227a4aed.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f40582ffba7917651b3b46c433da77733221b99f37d0a2e4deb5e29a76356338.jpeg",
    "https://cdn.faire.com/fastly/77e5ccc42a49e4c9b64a24de2a02b7d301de30f26817fac4ed299b5a1f87f8ef.jpeg",
    "https://cdn.faire.com/fastly/bbd6632e65342dcdc9a829e17f23a882df3546d39359e6e841986d4fde00fd6b.jpeg",
    "https://cdn.faire.com/fastly/8a0dc15f7c6596f476e314c8bcd9300e97268b3c06a65f20b3f201c3887b0449.jpeg",
    "https://cdn.faire.com/fastly/2028e3f84ce8f4ba423c23bb038b4cdb1bd573d56584cb06df7f387a0f8b81aa.jpeg",
    "https://cdn.faire.com/fastly/238e8a38f1df989358fc2c592819fb09837c1f45b363bc941c671314cf4bf70d.jpeg",
    "https://cdn.faire.com/fastly/194656a33c212cfbb9869522e45aed3d1d2997e192a61f9b0f7f279e169a1002.jpeg",
    "https://cdn.faire.com/fastly/b8da310fe5f3b68c7b17e1ca35c9c2e912341cff233e044cd4f6c125e447e086.jpeg",
    "https://cdn.faire.com/fastly/291bb3c71185e46b23c14ef1fd1ceffdb102c41fe6130ea1898bdb353396fd1d.jpeg",
    "https://cdn.faire.com/fastly/72553bd5c376aa87f98e238e4bd0f5a1ef7df624b15506ca9fa8f3aab45da3b5.jpeg",
    "https://cdn.faire.com/fastly/11c94b108b95f14ec0c2d25205736a6e3819208f63124dfde4aa2bed06e7d32c.jpeg",
    "https://cdn.faire.com/fastly/2b9e404d6e66a611e15e251e1ed34b4f80c44d5ece833e0bd769a152ec3cceae.jpeg",
    "https://cdn.faire.com/fastly/f4cff8d09dc589b23387ed855440c034403312204582f084aac4c7d548c689eb.jpeg",
    "https://cdn.faire.com/fastly/fa079db8a82004d3170cb148e74584ab6d5617d5d05870159fd5d129cfe1b7a3.jpeg",
    "https://cdn.faire.com/fastly/757483461d305e881ae3528231990e94fbd66235bae2578e67c0c33ffa5fa973.jpeg",
    "https://cdn.faire.com/fastly/2545978beb900861ea86658271b3f32ab8edfa0a57d406c4eabc2edd53dfc21a.jpeg",
    "https://cdn.faire.com/fastly/ef22a54dd7e7cbfb91fd3f31c27fb5fd9115362fd820cbd3ce246f53954df8c1.jpeg",
    "https://cdn.faire.com/fastly/d5e1b47c9a61080db25f739a4c1f3d24fc88fc24d04b9984dc4afb57212cb318.jpeg",
    "https://cdn.faire.com/fastly/18503504e6c3d2220f569902f23a4896cfd78f0a3ddce02137b99f4854b36940.jpeg",
    "https://cdn.faire.com/fastly/505d7078cf1d079949876c192d6bc4ed3d2cd7a256e178282589d42bc7844fc0.jpeg",
    "https://cdn.faire.com/fastly/02ac78d3a4866c540d79255b8dca1211699f17b0e0fb7024717bc119f2bd9b60.jpeg",
    "https://cdn.faire.com/fastly/f6a32a37d47be9819d749e66da98c42c35ee4451e9e75ddba922380bf4f333a7.jpeg",
    "https://cdn.faire.com/fastly/27424b8d3e4f1d4b0afa476b518e8c82d92df5d0612823dc9657db6c6e6fc451.jpeg",
    "https://cdn.faire.com/fastly/51ff15a81a7182b3ff4a025426aa16375b7d94a0c3d83613095ad568fe805fe8.jpeg",
    "https://cdn.faire.com/fastly/4f480b561de8692930347512628470740ba5796efa3afbeede7f85decbadab8e.jpeg",
    "https://cdn.faire.com/fastly/a7b56d48304f6859e8ed8026f7c5723233aacc72b9f9fcf626bf39f9d52c9757.jpeg",
    "https://cdn.faire.com/fastly/afaab1c3c606d915c61074cf4c1312a01af0ba3ab0ecd4fbd6dfe12c46d60cd2.jpeg",
    "https://cdn.faire.com/fastly/5ea460766a96cf7abd5fc0997680e0e05f1f577af4d564d3688ce64cf4cfa3b9.jpeg",
    "https://cdn.faire.com/fastly/70cf2b8b9f6c81a25130ec7965c4cb87210050f46ddc2beaa948606eca2c49ab.jpeg",
    "https://cdn.faire.com/fastly/9b02d41b27af27dd45860b7c7fdde5adcf44e91dd0b3c2641deb5075bb0968f0.jpeg",
    "https://cdn.faire.com/fastly/0c919ad7f2fedaf1c141a852b03bd22f7f1f985e3ecf367fef61bece946176bd.jpeg",
    "https://cdn.faire.com/fastly/3936f62e83195cae1deab2ac24d9b3dc1c436943cdd13e8253c903d4033c7278.jpeg",
    "https://cdn.faire.com/fastly/b208681ecaf2d0e48285c41aae288e0520cd97a2d3c5b139aa89afaf65773794.jpeg",
    "https://cdn.faire.com/fastly/0bf57b58deab339298cdc894c5d3930d97ca67231c82b87dd6dab8e3ebe10a37.jpeg",
    "https://cdn.faire.com/fastly/20d8c389110a4c95af1d657fa121edda7d648d4133302feb85e3fe5859320845.jpeg",
    "https://cdn.faire.com/fastly/ea57a9aa46a99b6c7e9fe40132e589d2671d46d2fab18b4ec6a017cfc3368d0f.jpeg",
    "https://cdn.faire.com/fastly/dc97932d7a50b9a8d70419e5af91d6a767c3c68215c8338c0dc99ef973918121.jpeg",
    "https://cdn.faire.com/fastly/00028fadae0b9da7b0d0e6adc7847b869b74c7f1b87bb59edd4c251f8e82f7b9.jpeg",
    "https://cdn.faire.com/fastly/8092a89cb3410742546628ef99576556f37ac54ae07afea29ee0eab6f68af514.jpeg",
  ],
  priceDollars: 174,
  description:
    'Model is wearing a size small\n\n𝗠𝗼𝗱𝗲𝗹 𝗦𝗽𝗲𝗰𝘀\nHeight: 5\'8"\nBust: 32B\nWaist: 24"\nHips: 34"',
  tags: [],
  msrpDollars: 348,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-13T17:05:56.758Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
